import { teamStandingsConverter, teamStandingsToDoc } from 'api/converters/TeamStandingsConverter';
import { collection, doc, getDocs, writeBatch } from 'firebase/firestore';
import { ITeamStandings, SeasonID } from 'types';
import { db } from '../lib/firebase';

export const saveStandings = async (standings: ITeamStandings[], collectionPath: string): Promise<void> => {
  const batch = writeBatch(db);
  const collectionData = collection(db, collectionPath).withConverter(teamStandingsConverter);
  standings.forEach((standing) => {
    const docRef = doc(collectionData, standing.uID);
    batch.set(docRef, teamStandingsToDoc(standing));
  });
  return await batch.commit();
};

export const saveTeamStandings = async (standings: ITeamStandings[], year: SeasonID = '2024'): Promise<void> => {
  return await saveStandings(standings, `stats/${year}/standings`);
};

export const saveOldTeamStandings = async (standings: ITeamStandings[], year: SeasonID = '2024'): Promise<void> => {
  return await saveStandings(standings, `teamstandings${year}`);
};

export const fetchStandings = async (collectionPath: string): Promise<ITeamStandings[]> => {
  const collectionData = collection(db, collectionPath).withConverter(teamStandingsConverter);
  const snapshot = await getDocs(collectionData);
  const standings: ITeamStandings[] = [];
  snapshot.forEach((doc) => {
    const standing = doc.data();
    standings.push(standing);
  });
  return standings;
};

export const fetchTeamStandings = async (year: SeasonID = '2024'): Promise<ITeamStandings[]> => {
  return await fetchStandings(`stats/${year}/standings`);
};

export const fetchOldTeamStandings = async (year: SeasonID = '2024'): Promise<ITeamStandings[]> => {
  return await fetchStandings(`teamstandings${year}`);
};
